export default __webpack_public_path__ + "static/media/capsule-landing-token-arbitrum.93134268.png";